import {Company} from '@/types/company';
import {CompanyUser} from '@/types/user';
import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface CompanyDataState {
  company: Company;
  companyForm: Company;
  employees: CompanyUser[];
}

const defaultCompanyInfo: Company = {
  _id: '',
  accessCodes: [],
  title: '',
  email: '',
  logo: '',
  imprint: {
    url: '',
    labels: {
      de: '',
      en: ''
    }
  },
  modules: [],
  welcome: '',
  labelLanguage: 'de',
  logoUploaded: false,
  allowedSports: []
};

const initialState: CompanyDataState = {
  company: {
    ...defaultCompanyInfo
  },
  companyForm: {
    ...defaultCompanyInfo
  },
  employees: []
};

const companyDataSlice = createSlice({
  name: 'companyData',
  initialState,

  reducers: {
    setCompanyFormData(state, action: PayloadAction<Partial<Company>>) {
      state.companyForm = {
        ...state.companyForm,
        ...action.payload
      };
    },

    resetCompanyFormData(state) {
      state.companyForm = {
        ...state.company
      };
    },

    setCompanyData(state, action: PayloadAction<Partial<Company>>) {
      const newData = {...state.company, ...action.payload};

      state.company = newData;
    },
    resetCompanyData(state) {
      state.company = initialState.company;
    },
    setEmployeesInRedux(state, action: PayloadAction<CompanyUser[]>) {
      state.employees = action.payload;
    },

    removeEmployeeFromRedux(
      state,
      action: PayloadAction<{employeeId: string}>
    ) {
      state.employees = state.employees.filter(
        (employee) => employee._id !== action.payload.employeeId
      );
    },

    updateEmployeeInRedux(
      state,
      action: PayloadAction<{employee: CompanyUser}>
    ) {
      const {employee} = action.payload;
      const index = state.employees.findIndex((e) => e._id === employee._id);
      if (index !== -1) {
        state.employees[index] = employee;
      }
    }
  }
});

export const {
  setCompanyFormData,
  resetCompanyFormData,
  setCompanyData,
  resetCompanyData,
  setEmployeesInRedux,
  removeEmployeeFromRedux,
  updateEmployeeInRedux
} = companyDataSlice.actions;
export default companyDataSlice.reducer;
